export default __webpack_public_path__ + "static/media/DAIF_Services_Screen4_in.0d94fd45.mp4";